import React, { Fragment, useEffect, useState } from "react";
import { get, child, ref } from "firebase/database";
import { rtdb, COLLECTIONS } from "../../firebase";
import { getCachedFooter, setCachedFooter } from "../../utils/siteConfigCache";
import { maintenanceFallback } from "./maintenanceFallback";
import "./maintenance.css";
import FooterModel from "../../components/pagesModel/FooterModel";
import APP_CONFIG from "../../config";
import NewsletterForms from "../../components/contact/NewsletterForms";

const MaintenancePage = () => {
    const [footerData, setFooterData] = useState(getCachedFooter());
    const [showContent, setShowContent] = useState(false);

    // Modal accès spécial
    const [showModal, setShowModal] = useState(false);
    const [email, setEmail] = useState("");
    const [code, setCode] = useState("");
    const [error, setError] = useState("");
     // Modal fonctionnalité
    const [featureModal, setFeatureModal] = useState(null);

    /* =========================
       FETCH FOOTER + MAINTENANCE
       ========================= */
    useEffect(() => {
        const fetchFooter = async () => {
            if (getCachedFooter()) return;

            try {
                const snapshot = await get(
                    child(
                        ref(rtdb),
                        `${COLLECTIONS.SITE_HEADER_FOOTER_MODEL}/footer_model`
                    )
                );

                if (snapshot.exists()) {
                    const data = snapshot.val();
                    setCachedFooter(data);
                    setFooterData(data);
                }
            } catch (err) {
                console.error("Erreur chargement footer :", err);
            }
        };

        fetchFooter();
    }, []);

    useEffect(() => {
        if (footerData) {
            requestAnimationFrame(() =>
                requestAnimationFrame(() => setShowContent(true))
            );
        }
    }, [footerData]);

    if (!footerData) return null;

    /* =========================
       DATA
       ========================= */
    const data = footerData;
    const maintenanceData =
        footerData?.maintenanceData || maintenanceFallback;

    const {
        footer_logo,
        about_text,
        social_links,
        quick_links,
        service_links,
        contact,
        copyright,
    } = data.footer_param;

    const { bg_checked, bg_color, text_color, text_color_hover } = data;

    const footerStyle = {
        color: text_color || "#fff",
        ...(bg_checked === "bg_color"
            ? { backgroundColor: bg_color || "#000" }
            : {}),
    };

    /* =========================
       ACCÈS SPÉCIAL
       ========================= */
    const grantAccess = () => {
        const allowed = maintenanceData?.acces_permission?.some(
            (u) =>
                u.user_email === email.trim() &&
                u.acces_code === code.trim()
        );

        if (!allowed) {
            setError("Accès refusé. Identifiants invalides.");
            return;
        }

        localStorage.setItem(
            "special_access",
            JSON.stringify({ email, code })
        );

        window.location.reload();
    };

    /* =========================
       RENDER
       ========================= */
    return (
        <>
            <div>
                {/* Barre au-dessus du hero */ }
                <div
                    style={ {
                        height : "3cm" ,
                        backgroundColor : "#ffffff" , // même couleur feu si tu veux
                        width : "100%"
                    } }
                ></div>

            </div>


            {/* ===============================
          HERO MAINTENANCE
      =============================== */ }
            <section className="hero">
                <div className="container">
                    <div className="hero-content">
                        <div className="hero-text fade-in">
                            <div className="hero-badge">
                                <span>{ maintenanceData.hero.badge_icon }</span>
                                <span>{ maintenanceData.hero.badge_text }</span>
                            </div>

                            <h1 className="hero-title">{ maintenanceData.hero.title }</h1>
                            <h4
                                className="hero-subtitle"
                                style={ { color : "#AE1917" } }  // jaune feu
                            >
                                { maintenanceData.hero.subtitle }
                            </h4>

                            <p className="hero-description">
                                { maintenanceData.hero.description }
                            </p>

                        </div>

                        <div className="hero-image fade-in">
                            <div className="hero-card">
                                <div className="hero-card-inner">
                                    <div className="hero-card-content">
                                        <div className="hero-card-icon">
                                            { maintenanceData.card.icon }
                                        </div>

                                        <h3 className="hero-card-title">
                                            { maintenanceData.card.title }
                                        </h3>

                                        <p className="hero-card-text">
                                            { maintenanceData.card.text }
                                        </p>

                                        <div className="hero-features-grid">
                                            { maintenanceData.card.features.map ( ( f , i ) => (
                                                <div
                                                    key={ i }
                                                    className="hero-feature-item clickable"
                                                    onClick={ () => setFeatureModal ( f ) }
                                                >
                                                    <div className="hero-feature-icon">
                                                        { f.icon }
                                                    </div>
                                                    <div className="hero-feature-label">
                                                        { f.label }
                                                    </div>
                                                </div>
                                            ) ) }
                                        </div>

                                    </div>
                                </div>
                            </div>

                            <div className="hero-floating-badge">
                                <span>{ maintenanceData.hero.floating_badge.icon }</span>
                                <span>{ maintenanceData.hero.floating_badge.text }</span>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* ===============================
          NEWSLETTER
      =============================== */ }

            {/* Newsletter en mode maintenance */}
            <NewsletterForms userdIn="inmaintenance" />


            {/* Boutons d'action */ }
            <section className="final-cta">
                <div className="container">


                    {/* Boutons d'action */ }
                    <div className="final-cta-buttons">
                        <a href="https://zayado.net/" className="btn-primary">
                            Rejoindre Zayado
                        </a>
                        <a href="/donate" className="btn-secondary">
                            💖 Faire un don
                        </a>
                        <button
                            className="btn-secondary"
                            onClick={ () => setShowModal ( true ) }
                        >
                            Accès spécial
                        </button>
                    </div>

                </div>
            </section>


            {/* ===============================
          MODAL ACCÈS SPÉCIAL
      =============================== */ }
            {/* ===============================
      MODAL ACCÈS SPÉCIAL
=============================== */}
            {showModal && (
                <div className="maintenance-modal-overlay">
                    <div className="maintenance-modal">
                        <h3>Accès spécial</h3>

                        <input
                            type="email"
                            placeholder="Email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />

                        <input
                            type="password"
                            placeholder="Code secret"
                            value={code}
                            onChange={(e) => setCode(e.target.value)}
                        />

                        {error && <p className="error-text">{error}</p>}

                        <div className="modal-actions">
                            <button
                                className="btn-primary"
                                onClick={() => {
                                    const acces_permission=APP_CONFIG.ACESS_USERS
                                    console.log("Accès permissions :",  acces_permission);
                                    console.log("Email entré :", email);
                                    console.log("Code entré :", code);

                                    const permissions = Array.isArray(acces_permission)
                                        ? acces_permission
                                        : [];

                                    const allowed = permissions.some(
                                        (u) =>
                                            u.user_email?.toLowerCase() === email.trim().toLowerCase() &&
                                            u.acces_code?.toLowerCase() === code.trim().toLowerCase()
                                    );

                                    if (!allowed) {
                                        console.error("Accès refusé !");
                                        setError("Accès refusé. Identifiants invalides.");
                                        return;
                                    }

                                    console.log("Accès accordé !");
                                    localStorage.setItem(
                                        "special_access",
                                        JSON.stringify({ email, code })
                                    );

                                    window.location.reload();
                                }}
                            >
                                Valider
                            </button>

                            <button
                                className="btn-secondary"
                                onClick={() => {
                                    setShowModal(false);
                                    setError("");
                                }}
                            >
                                Annuler
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* ===============================
    MODAL FEATURE
================================ */}
            {featureModal && (
                <div
                    className="maintenance-modal-overlay"
                    onClick={() => setFeatureModal(null)}
                >
                    <div
                        className="maintenance-modal feature-modal"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div style={{ fontSize: "3rem", marginBottom: "1rem" }}>
                            {featureModal.icon}
                        </div>

                        <h3 style={{ marginBottom: "1rem" }}>
                            {featureModal.label}
                        </h3>

                        <p style={{ marginBottom: "1.5rem" }}>
                            {featureModal.description ||
                                "Cette fonctionnalité permettra aux membres de vivre une expérience spirituelle enrichissante sur TheSustain."}
                        </p>

                        <button
                            className="btn-primary"
                            onClick={() => setFeatureModal(null)}
                        >
                            Fermer
                        </button>
                    </div>
                </div>
            )}

            {/* ===============================
          FOOTER
      =============================== */ }
            <div
                style={ {
                    opacity : showContent ? 1 : 0 ,
                    transition : "opacity 1s ease-in-out" ,
                } }
            >
                <Fragment>
                    { text_color_hover && (
                        <style>{ `
              .main-footer *:hover {
                color: ${ text_color_hover } !important;
              }
            ` }</style>
                    ) }

                    <FooterModel data={ footerData }/>
                </Fragment>
            </div>
        </>
    );
};

export default MaintenancePage;
